import React, { useEffect, useState } from 'react'
import { Dropdown, Menu } from 'antd'
import { Button } from 'reactstrap'
import { FormattedMessage } from 'react-intl'
import styles from './style.module.scss'
import {InfoIcon, UpdateIcon} from '../../../../../config/icons'
import { getUpdatesList } from '../../../../../services/api'
import {TooltipIcon} from "../../../../platform/Table/TooltipIcon";

const Updates = () => {
  const [updatesList, setUpdatesList] = useState([])

  useEffect(() => {
    getUpdatesList().then(response => {
      setUpdatesList(response.data.posts)
    })
  }, [])

  const menu = (
    <div className={styles.dialog}>
      <Menu selectable={false} className={styles.menu}>
        <Menu.Item key={'header'} style={{ marginTop: 12 }}>
          <div className={styles.title}>
            <InfoIcon className={styles.titleIcon} />
            <strong style={{ fontSize: 18, color: 'black' }}>
              <FormattedMessage id={'global.anouncements'} />
            </strong>
          </div>
        </Menu.Item>
        {updatesList.map((item, counter) => {
          return (
            <Menu.Item key={item.id} style={{ marginLeft: 35, height: 'auto' }}>
              <div className={styles.item}>
                <div className={styles.counter}>{counter + 1})</div>
                <div className={styles.text}>
                  <b>{item.titolo || <FormattedMessage id={'global.unvalid_title'} />}</b>:{' '}
                  {item.descrizione ? (
                    item.descrizione
                  ) : (
                    <FormattedMessage id={'global.unvalid_title'} />
                  )}
                </div>
              </div>
            </Menu.Item>
          )
        })}
        <Menu.Item key={'footer'} className={styles.lastItem} style={{ marginLeft: 35 }}>
          <Button color={'primary'} data-toggle="dropdown">
            <FormattedMessage id="global.got_it" />
          </Button>
        </Menu.Item>
      </Menu>
    </div>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
      <span className={styles.updates}>
        <TooltipIcon
          title={<FormattedMessage id='candidati.updates' />}
          Icon={UpdateIcon}
          className={styles.icon}
        />
      </span>
    </Dropdown>
  )
}

export default Updates
